<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Cambiar motorizado</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Dealer -->
        <div>
          <label class="text-sm opacity-75">Motorizado*</label>
          <v-select :options="dealers"
                    label="displayName"
                    :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="document.dealer"
                    class="mb-4 md:mb-0 w-full"
                    name="dealer"/>
        </div>
        <!--End--->
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="          margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { db } from '@/firebase/firebaseConfig'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    dealers: {}
  },
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      document: {
      },
      status: [
        {
          label: 'Sin confirmar',
          value: 'hold'
        },
         {
          label: 'Recogido',
          value: 'confirmed'
        },
        {
          label: 'Entregado',
          value: 'done'
        },
        {
          label: 'Anulado',
          value: 'canceled'
        },
        {
          label: 'Rechazado',
          value: 'rejected'
        },
        {
          label: 'Reprogramado sin cobro',
          value: 'rescheduledWithoutCharge'
        },
        {
          label: 'Reprogramado con cobro',
          value: 'rescheduledWithCharge'
        },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.document = {
          ...this.data
        }
        this.$validator.reset()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    /**
     * Save data in firestore
     * @returns {Promise<void>}
     */
    async submitData() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true

          let obj = {
            ...this.document
          }
          await db.collection('assignments').doc(this.document.id).update({
            dealer: this.document.dealer
          })

          this.$emit('closeSidebar')
          this.$emit('update', obj)

          this.$vs.notify({
            color: 'success',
            title: 'Asignación',
            text: 'Recojo actualizado correctamente.'
          })
        }
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error'
        })
      } finally {
        this.progress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52011;
  }

  ::v-deep .vs-sidebar {
    z-index: 52011;
    width: 450px !important;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
